import sanityClient from '@sanity/client'

export default sanityClient({
    projectId:"171195p7",
    dataset:"production"
})